import { SyntheticEvent, useEffect, useState } from "react";
import { NewFieldLabel, NewFieldStyleOverrides, TextField } from "~components";
import { phoneMask, useTestIds } from "~utils";

type PhoneFieldProps = {
  onChange?: (value: string) => void;
  placeholder?: string;
  value?: string;
  // TODO: This is temporary until we update fields site wide
  useConfigurationStyle?: boolean;
  disabled?: boolean;
};

export function PhoneField(props: PhoneFieldProps) {
  const { onChange, placeholder, value = "", useConfigurationStyle = false, disabled } = props;
  const { onInput, onKeydown, mask, unMask } = phoneMask();
  const [internalInputValue, setInternalInputValue] = useState<string>(mask(value));
  const tid = useTestIds(props, "phoneField");

  // Update internal input value when value prop changes (e.g., when form is pre-populated)
  useEffect(() => {
    setInternalInputValue(mask(value));
  }, [value]);

  function onChangeInternal(e: SyntheticEvent) {
    const { newValue } = onInput(e);
    // use masked value for internal input
    setInternalInputValue(newValue);
    // provide un-masked value to caller
    onChange?.(unMask(newValue));
  }

  return (
    <TextField
      disabled={disabled}
      onChange={onChangeInternal}
      onKeyDown={onKeydown}
      placeholder={placeholder}
      type="tel"
      value={internalInputValue}
      autoComplete="tel"
      {...(useConfigurationStyle && {
        cssOverrides: NewFieldStyleOverrides,
        label: NewFieldLabel("Phone (optional)"),
      })}
      {...tid}
    />
  );
}
